/**
 * 部署后若浏览器仍引用旧 index.html / 旧 chunk 名，动态 import 或拆包脚本会 404，
 * 表现为先闪一下再白屏。注册后自动刷新 1～2 次以拉取最新 HTML。
 */
const ATTEMPTS_KEY = "msCentral:his:chunkReloadAttempts";
const MAX_ATTEMPTS = 2;

export function clearChunkReloadAttempts(): void {
  if (typeof sessionStorage === "undefined") return;
  sessionStorage.removeItem(ATTEMPTS_KEY);
}

function isChunkOrDynamicImportFailure(reason: unknown): boolean {
  if (reason == null) return false;
  const err = reason as { name?: string; message?: string };
  const name = typeof err.name === "string" ? err.name : "";
  const message = typeof err.message === "string" ? err.message : String(reason);
  return (
    name === "ChunkLoadError" ||
    /Loading chunk [\w.-]+ failed/i.test(message) ||
    /Failed to fetch dynamically imported module/i.test(message) ||
    /Importing a module script failed/i.test(message) ||
    /error loading dynamically imported module/i.test(message)
  );
}

export function registerChunkLoadRecovery(): void {
  if (typeof window === "undefined") return;

  window.addEventListener(
    "unhandledrejection",
    (event: PromiseRejectionEvent) => {
      if (!isChunkOrDynamicImportFailure(event.reason)) return;
      const n = Number.parseInt(sessionStorage.getItem(ATTEMPTS_KEY) || "0", 10);
      if (n >= MAX_ATTEMPTS) {
        console.error("[chunkLoadRecovery] 已达最大自动刷新次数，请强制刷新或清缓存", event.reason);
        return;
      }
      sessionStorage.setItem(ATTEMPTS_KEY, String(n + 1));
      event.preventDefault();
      // eslint-disable-next-line no-console
      console.warn("[chunkLoadRecovery] 检测到拆包/动态模块加载失败，将刷新页面以获取新版本");
      window.location.reload();
    },
  );

  window.addEventListener(
    "error",
    (event: ErrorEvent) => {
      const t = event.target;
      if (!t || !(t instanceof HTMLElement)) return;
      if (t.tagName !== "SCRIPT") return;
      const src = (t as HTMLScriptElement).src;
      if (!src || !src.includes("/static/js/")) return;
      const n = Number.parseInt(sessionStorage.getItem(ATTEMPTS_KEY) || "0", 10);
      if (n >= MAX_ATTEMPTS) return;
      sessionStorage.setItem(ATTEMPTS_KEY, String(n + 1));
      // eslint-disable-next-line no-console
      console.warn("[chunkLoadRecovery] 脚本资源加载失败，将刷新页面", src);
      window.location.reload();
    },
    true,
  );
}
